/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../utils/SkeletonSettings";

export const RecipeListRowSkeleton = (props) => (
    <ContentLoader
        height={50}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderTop: "1px solid #cfcfcf"}}
        {...props}>

        {/* Product name */}
        <rect x="0" y="50%" rx="3" ry="3" width="30%" height="10"/>

        {/* Properties */}
        <rect x="70%" y="50%" rx="3" ry="3" width="30%" height="10"/>


    </ContentLoader>
)
